import { X } from "lucide-react";
import baseStyles from "./FilterPillRow.module.css";

interface FilterPillRowProps {
  filters: string[];
  onClear: (filter: string) => void;
}

export const FilterPillRow = ({ filters, onClear }: FilterPillRowProps) => {
  return (
    <div className={baseStyles.pillRow}>
      {filters.map((filter) => (
        <div
          key={filter}
          className={baseStyles.pill}
          data-cy="filter-pill"
          data-value={filter}
        >
          <p>{filter}</p>
          <button
            className={baseStyles.pillRemove}
            onClick={() => {
              onClear(filter);
            }}
            data-cy="delete-filter-pill-button"
            data-value={filter}
          >
            <X size={18} />
          </button>
        </div>
      ))}
    </div>
  );
};
